import React, { useContext } from 'react';
import InterSitial from '../../../../hoc/components/intersitial';
import context from '../../../../hoc/context/product/context';

export interface GoogleDisclaimerProps {
	className?: string;
}

export const GoogleDisclaimer: React.FC<GoogleDisclaimerProps> = ({
	className = '',
}) => {
	const ctxt = useContext(context);

	return (
		<p className={className}>
			{ctxt.json.pages.userProfile.googleMapsDisclaimer1 + ' '}
			<InterSitial
				link={ctxt.json.pages.userProfile.googleTermsLink}
				rel="noopener noreferrer"
				target="_blank"
				className="underline inline break-all"
				eventLabel="Google Terms Link">
				{ctxt.json.pages.userProfile.googleTermsLink}
			</InterSitial>
			{ctxt.json.pages.userProfile.googleMapsDisclaimer2 + ' '}
			<InterSitial
				link={ctxt.json.pages.userProfile.googlePrivacyLink}
				rel="noopener noreferrer"
				target="_blank"
				className="underline inline break-all"
				eventLabel="Google Privacy Link">
				{ctxt.json.pages.userProfile.googlePrivacyLink}
			</InterSitial>
			.
		</p>
	);
};
